import dayjs from 'dayjs';

export const MIN_YEAR = 1900;
export const MAX_YEAR = new Date().getFullYear() + 10;

export const POLISH_MONTHS = [
  'Styczeń',
  'Luty',
  'Marzec',
  'Kwiecień',
  'Maj',
  'Czerwiec',
  'Lipiec',
  'Sierpień',
  'Wrzesień',
  'Październik',
  'Listopad',
  'Grudzień',
] as const;

export const POLISH_MONTHS_SHORT = [
  'Sty',
  'Lut',
  'Mar',
  'Kwi',
  'Maj',
  'Cze',
  'Lip',
  'Sie',
  'Wrz',
  'Paź',
  'Lis',
  'Gru',
] as const;

export const clampDayToMonth = (
  year: number,
  monthIdx: number,
  day: number,
): Date => {
  const lastDay = dayjs(new Date(year, monthIdx, 1)).daysInMonth();
  return new Date(year, monthIdx, Math.min(day, lastDay));
};

export const parseStrictDdMmYyyy = (text: string): Date | undefined => {
  const parsed = dayjs(text, 'DD.MM.YYYY', true);
  return parsed.isValid() ? parsed.toDate() : undefined;
};

export const formatDdMmYyyy = (date: Date | undefined): string =>
  date ? dayjs(date).format('DD.MM.YYYY') : '';

export const applyDateMask = (raw: string): string => {
  const out: string[] = [];
  let digits = 0;
  for (const ch of raw) {
    if (digits === 8) break;
    const atDotSlot = out.length === 2 || out.length === 5;
    if (atDotSlot) {
      if (ch === '.') {
        out.push('.');
        continue;
      }
      if (/\d/.test(ch)) {
        out.push('.', ch);
        digits++;
        continue;
      }
      continue;
    }
    if (/\d/.test(ch)) {
      out.push(ch);
      digits++;
    }
  }
  return out.join('');
};
